import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import authReducer from './slices/auth/authSlice';
import bioLinkReducer from './slices/bioLink/bioLinkSlice';
import gettingBioLinkReducer from './slices/getLink/getLinkSlice';
import blocksliceReducer from './slices/block/createBlockSlice';
import linkBlockReducer from './slices/block/createBioLinkButtonSlice';
import youtubeBlockReducer from './slices/block/createYoutubeBlockSlice';
import faqBlockReducer from './slices/block/createFaqBlockSlice';
import tikTokBlockReducer from './slices/block/createTikTokBlock';
import socialBlockReducer from './slices/block/createSocialBlock';
import changeStatusReducer from './slices/block/changeStatusBlockSlice';
import linkListReducer from './slices/gettingLinksList/gettingLinkListSlice';
import cardReducer from './slices/cards/cardSlice';
import settingFieldReducer from './slices/settingField/settingFieldSlice';
import mainScreanReducer from './slices/linkPreview/linkPreviewSlice';
import paymentStripesReducer from './slices/paymentStripes/paymentStripesSlice';
import ImageGridReducer from './slices/imageGrid/ImageGridSlice';
import taxesReducer from './slices/taxes/taxesSlice';
import seoSettingsReducer from './slices/seo-settings/seoSettingsSlice';
import codesRecucer from './slices/codes/codesSlices';
import userReducer from './slices/user/userSlice';
import qrcodesReducer from './slices/block/createShareSlice'
// ----------------------------------------------------------------------
const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  user: authReducer,
  bioLinkCreated: bioLinkReducer,
  gettingBioLinksState: gettingBioLinkReducer,
  blockHeading: blocksliceReducer, //  reducer for all modal in Cretae block
  linkBlock: linkBlockReducer,
  youtubeBlock: youtubeBlockReducer,
  faqBlock: faqBlockReducer,
  tikTokBlock: tikTokBlockReducer,
  socialBlock: socialBlockReducer,
  changeBLock: changeStatusReducer,
  linkList: linkListReducer,
  cards: cardReducer,
  settingField: settingFieldReducer,
  linkPreview: mainScreanReducer,
  paymentStripes: paymentStripesReducer,
  imageGrid: ImageGridReducer,
  taxes: taxesReducer,
  seoSettings: seoSettingsReducer,
  codes: codesRecucer,
  adminUser: userReducer,
  shareQRCode: qrcodesReducer,
});
export { rootPersistConfig, rootReducer };
